import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-muted-foreground" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <span key={it.path} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3 w-3" />}
          {i === items.length - 1 ? (
            <span className="text-foreground">{it.name}</span>
          ) : (
            <Link to={it.path} className="hover:text-primary">{it.name}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
